import { NAME as PARENT_NAME } from '../constants';

export const NAME_FRAGMENT = 'review' as const;
export const NAME = `${PARENT_NAME}/${NAME_FRAGMENT}` as const;
